const formatBeverlyWilshire = (name: string) => {
	if (/beverly wilshire/gi.test(name)) {
		return name.replace(
			/(beverly wilshire,)(?:( beverly hills,))? (a four seasons hotel)/gi,
			'$1$2 <span style="font-size: .8em;">$3</span>'
		);
	}
	return name;
};

export default formatBeverlyWilshire;
